import logitravelCalendarStyles from "./styles/logitravel.js";
import partnershipsCalendarStyles from "./styles/partnerships.js";
import smyCalendarStyles from "./styles/smy.js";
import universalMusicCalendarStyles from "./styles/universalMusic.js";
import veciCalendarStyles from "./styles/veci.js";
const calendarThemes = {
    logitravel: logitravelCalendarStyles,
    partnerships: partnershipsCalendarStyles,
    smy: smyCalendarStyles,
    veci: veciCalendarStyles,
    partnershipsUniversalMusic: universalMusicCalendarStyles
};
export default calendarThemes;

//# sourceMappingURL=index.js.map